// @flow

// !!! IMPORTANT !!!
//
// This file is shared between the zapier/zapier and zapier/next-js repository.
// Any changes made here should be reflected in there as well.
// For more information, see: https://zapier.quip.com/xaKqAOpdhpY2#ZXFACA8Jnp9
import React from 'react';
import bemify, { toModifiers } from 'bemify-js';

import 'app/common/components/Separator.scss';

import type { Node } from 'react';

import type { KindType } from 'app/common/types';

const bem = bemify('separator');

type Props = {
  children: Node,
  kind?: KindType,
};

const Separator = (props: Props) => {
  const { children, kind } = props;

  return (
    <div className={bem(toModifiers(kind))}>
      <span className={bem('__content')}>{children}</span>
    </div>
  );
};

export default Separator;
